"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _intl = require("@kyruus/intl");
var _button = _interopRequireDefault(require("@kyruus/button"));
var _stepper = _interopRequireWildcard(require("@kyruus/stepper"));
var _messages = _interopRequireDefault(require("../../lib/messages"));
var _styles = require("./styles");
var _DesktopHeaderSkeleton = _interopRequireDefault(require("./DesktopHeaderSkeleton"));
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const DesktopHeader = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  var _context;
  let {
    activeStep,
    onGoBack,
    stepsConfiguration
  } = _ref;
  if (!stepsConfiguration) {
    return /*#__PURE__*/_react.default.createElement(_styles.Container, {
      "data-testid": "HeaderSkeleton",
      ref: ref
    }, /*#__PURE__*/_react.default.createElement(_DesktopHeaderSkeleton.default, null));
  }
  return /*#__PURE__*/_react.default.createElement(_styles.Container, {
    "data-testid": "Header",
    aboveMd: true,
    ref: ref
  }, /*#__PURE__*/_react.default.createElement(_styles.StepperContainer, null, /*#__PURE__*/_react.default.createElement(_stepper.default, {
    orientation: "horizontal",
    activeStep: activeStep
  }, (0, _map.default)(_context = (0, _filter.default)(stepsConfiguration).call(stepsConfiguration, _ref2 => {
    let {
      stepperLabelId
    } = _ref2;
    return stepperLabelId !== null;
  })).call(_context, (_ref3, index) => {
    let {
      stateKey,
      stepperLabelId
    } = _ref3;
    return /*#__PURE__*/_react.default.createElement(_stepper.Step, {
      key: stepperLabelId
    }, /*#__PURE__*/_react.default.createElement(_stepper.StepLabel, null, index < activeStep ? /*#__PURE__*/_react.default.createElement(_button.default, {
      mode: "flat",
      onClick: () => onGoBack(stateKey)
    }, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default[stepperLabelId])) : /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default[stepperLabelId])));
  }))));
});
DesktopHeader.displayName = 'DesktopHeader';
DesktopHeader.propTypes = {
  // active step to highlight
  activeStep: _propTypes.string.isRequired,
  // callback for 'back' click
  onGoBack: _propTypes.func.isRequired,
  // steps configuration object. see constants/steps
  stepsConfiguration: _propTypes.object
};
var _default = exports.default = DesktopHeader;
DesktopHeader.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "DesktopHeader",
  "props": {
    "activeStep": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "onGoBack": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "stepsConfiguration": {
      "description": "",
      "type": {
        "name": "object"
      },
      "required": false
    }
  }
};